export default function getTextColor(color) {
  if (color.includes('rgb')) {
    return rgbContrastColor(color)
  } else if (color.includes('#')) {
    const rgb = hexToRGB(color)
    return rgbContrastColor(rgb)
  }
  return null
}

function rgbContrastColor(color) {
  const trim = color
    .trim()
    .replace('rgb', '')
    .replace('(', '')
    .replace(')', '')
  const split = trim.split(',')
  const contrast = Math.round(
    (split[0] * 299 + split[1] * 587 + split[2] * 114) / 1000
  )
  return contrast > 125 ? 'black' : 'white'
}

function hexToRGB(h) {
  let r = 0,
    g = 0,
    b = 0
  if (h.length === 4) {
    r = '0x' + h[1] + h[1]
    g = '0x' + h[2] + h[2]
    b = '0x' + h[3] + h[3]
  } else if (h.length === 7) {
    r = '0x' + h[1] + h[2]
    g = '0x' + h[3] + h[4]
    b = '0x' + h[5] + h[6]
  }
  return 'rgb(' + +r + ',' + +g + ',' + +b + ')'
}
